module.exports = __webpack_public_path__ + "static/media/phone-ring.d9289e25.svg";